import React, { Component } from 'react';

import Icon from './../../components/Icon';
import Emoji from './../../components/Emoji';

import { Link } from 'react-router-dom';
import OrderFooter from './OrderFooter';
import OrderNaModal from './OrderNaModal';
import OrderErrorModal from './OrderErrorModal';
import OrderInfo from './OrderInfo';
import OrderTabInfo from './OrderTabInfo';
import OrderTabMessages from './OrderTabMessages';
import OrderMessageBox from './OrderMessageBox';
import OrderTabQA from './OrderTabQA';
import OrderOpenActions from './OrderOpenActions';
import OrderNextButton from './OrderNextButton';

import classNames from './../../utils/classNames';
import { getStatus } from './../../utils/order';
import {
    STATUS_OPEN,
} from './../../store/orders/actions';

const bodyNoScrollClass = 'hide-scroll';
const TAB_INFO = 'TAB_INFO';
const TAB_MESSAGES = 'TAB_MESSAGES';
const TAB_QA = 'TAB_QA';

class Order extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tab: TAB_INFO,
            btnCompleteDisabled: true
        };

        this.onResize = this.onResize.bind(this);
        this.showTab = this.showTab.bind(this);
        this.onClickFavorite = this.onClickFavorite.bind(this);
        this.onNaCloseClick = this.onNaCloseClick.bind(this);
        this.onErrorCloseClick = this.onErrorCloseClick.bind(this);
        this.onSaveGradingReport = this.onSaveGradingReport.bind(this);
    }

    onClickFavorite(event) {
        const { order, setFavorite } = this.props;
        setFavorite(!order.is_favorite);
    }

    onResize() {
        this.filesStickyRef && this.filesStickyRef.handleMove();
        this.otherFilesStickyRef && this.otherFilesStickyRef.handleMove();
    }

    showTab(tab) {
        this.setState(state => Object.assign({}, state, { tab }));
    }

    componentDidUpdate(prevProps, prevState) {
        const { hasOrderInList, loadDetails, orderNumber, isLoadingAdd } = this.props;
        if ((!prevProps.hasOrderInList && hasOrderInList) || (prevProps.orderNumber !== orderNumber)) {
            loadDetails();
            this.showTab(TAB_INFO);
            this.setStatusButtonComplete();
        }
        const { tab } = this.state;
        if (this.containerRef && tab === TAB_MESSAGES) {
            if (prevState.tab !== tab || prevProps.isLoadingAdd !== isLoadingAdd) {
                this.containerRef.scrollTop = this.containerRef.scrollHeight;
            }
        }
    }

    componentDidMount() {
        const { standalone } = this.props;
        !standalone && document.body.classList.add(bodyNoScrollClass);
        const { hasOrderInList, loadOrders, loadDetails } = this.props;
        if (!hasOrderInList && loadOrders) {
            loadOrders();
            return;
        }
        loadDetails();
        this.setStatusButtonComplete();
    }

    componentWillUnmount() {
        const { standalone } = this.props;
        !standalone && document.body.classList.remove(bodyNoScrollClass);
    }

    renderFavoriteButton() {
        const { isLoading, order } = this.props;
        if (isLoading || order.writer_status !== 'client_paid') {
            return null;
        }
        const btnClassName = classNames('btn', 'btn-empty', { 'active': order.is_favorite });
        return (
            <div className="favorite-wrap">
                <button type="button" className={btnClassName} disabled={order.isFetchingFavorite} onClick={this.onClickFavorite}>
                    <Icon className="svg-icon" iconName="saved-star" />
                </button>
            </div>
        );
    }

    renderTabButton(tabName, text) {
        const { messageList } = this.props;
        const { tab } = this.state;
        const className = classNames('btn col-1', { 'active': tab === tabName });
        const newBtnClassName = classNames({
            'new': tabName === TAB_MESSAGES && (messageList).some(message =>
                message.recepient_role === 'pregrader' && (message.status === 'unread' || message.confirm_status === 'need_confirm')
            )
        });
        return (
            <button className={className} onClick={() => this.showTab(tabName)}><span className={newBtnClassName}>{text}</span></button>
        );
    }

    getRatingString() {
        const { order } = this.props;
        const pregraderRating = order.pregrader_assessing_avg;

        let pregraderRatingStr = `${pregraderRating} out of 100`;

        if (pregraderRating < 55) {
            pregraderRatingStr = `${pregraderRating} out of 100`;
        }


        if (pregraderRating >= 55 && pregraderRating <= 59) {
            pregraderRatingStr = `${pregraderRating} (F) out of 100`;
        }


        if (pregraderRating >= 60 && pregraderRating <= 69) {
            pregraderRatingStr = `${pregraderRating} (D) out of 100`;
        }


        if (pregraderRating >= 70 && pregraderRating <= 79) {
            pregraderRatingStr = `${pregraderRating} (C) out of 100`;
        }


        if (pregraderRating >= 80 && pregraderRating <= 89) {
            pregraderRatingStr = `${pregraderRating} (B) out of 100`;
        }


        if (pregraderRating >= 90 && pregraderRating <= 100) {
            pregraderRatingStr = `${pregraderRating} (A) out of 100`;
        }

        return pregraderRatingStr;
    }

    setStatusButtonComplete() {
        const btnCompleteDisabled = !this.props.order.pregrader_assessing_avg;
        this.setState({ btnCompleteDisabled });
    }

    onSaveGradingReport() {
        this.setState({
            btnCompleteDisabled: false
        });
    }

    getStatus() {
        const { order } = this.props;
        return getStatus(order);
    }

    onNaCloseClick() {
        const { hideInLists, onSelect, orderNumber } = this.props;
        hideInLists && hideInLists(orderNumber);
        onSelect && onSelect(orderNumber);
    }

    renderModal() {
        return (
            <div className="modal-wrap">
                <div className="modal-container modal-grader">
                    <h1>Not available</h1>
                    <p>This order has been already taken</p>
                    <div className="upload-button">
                        <Link className="btn btn-bright btn-big" to={`/findorders/all`}>Go it</Link>
                    </div>
                </div>
            </div>
        );
    }

    onErrorCloseClick() {
        const { onSelect, orderNumber } = this.props;
        onSelect(orderNumber);
    }

    renderContent() {
        const {
            order,
            fileItems,
            isStatusLoading,
            setAccepted,
            setCompleted,
            setMessageRead,
            messageList,
            uploadFile,
            removeFile
        } = this.props;

        const { tab, btnCompleteDisabled } = this.state;
        const status = this.getStatus();

        const classNameTab = classNames({ 'row-border': tab !== TAB_QA });

        return (
            <section className="order-detail-body">
                <div className={classNameTab}>
                    {tab !== TAB_MESSAGES &&
                        <div>
                            <h1>{order.title}</h1>
                            <div className="order-info-wrap">
                                <OrderInfo order={order} status={status} />
                            </div>
                        </div>
                    }
                    <OrderOpenActions
                        order={order}
                        isStatusLoading={isStatusLoading}
                        setAccepted={setAccepted}
                        setCompleted={setCompleted}
                        status={status}
                        btnCompleteDisabled={btnCompleteDisabled}
                    />
                    <div className="btn-toggle-group row vertical">
                        {this.renderTabButton(TAB_INFO, 'Order Info')}
                        {this.renderTabButton(TAB_MESSAGES, 'Messages')}
                        {status !== STATUS_OPEN && this.renderTabButton(TAB_QA, 'QA Report')}
                    </div>
                </div>
                {tab === TAB_INFO &&
                    <OrderTabInfo
                        order={order}
                        status={status}
                        uploadFile={uploadFile}
                        removeFile={removeFile}
                        fileItems={fileItems}
                        onResize={this.onResize}
                        setFilesStickyRef={ref => this.filesStickyRef = ref}
                        setOtherFilesStickyRef={ref => this.otherFilesStickyRef = ref}
                    />
                }
                {tab === TAB_MESSAGES &&
                    <OrderTabMessages fileItems={fileItems} messageList={messageList} setRead={setMessageRead} />
                }
                {tab === TAB_QA &&
                    <OrderTabQA
                        order={order}
                        status={status}
                        uploadFile={uploadFile}
                        removeFile={removeFile}
                        fileItems={fileItems}
                        onResize={this.onResize}
                        setFilesStickyRef={ref => this.filesStickyRef = ref}
                        setOtherFilesStickyRef={ref => this.otherFilesStickyRef = ref}
                        onSaveGradingReport={this.onSaveGradingReport}
                    />
                }
                {order.naError &&
                    <OrderNaModal onClose={this.onNaCloseClick} />
                }
                {order.assigned && !order.assigned_by_me &&
                    this.renderModal()
                }
            </section>
        )
    }

    render() {
        const { isLoading, orderNumber, error, onSelect, isLoadingAdd, addMessage, addMessageAttach, standalone, order, invalidate } = this.props;
        const { tab } = this.state;

        return (
            <div className="order-tab">
                <div className="order-tab-head">
                    {this.renderFavoriteButton()}
                    <span className="order-number">{orderNumber}</span>
                    <OrderNextButton isLoading={isLoading} orderNumber={orderNumber} />
                    {!!onSelect &&
                        <button className="btn btn-close" onClick={() => onSelect(orderNumber)}><Icon className="svg-icon" iconName="close" /></button>
                    }
                </div>
                <div className="order-tab-container" onScroll={this.onResize} ref={ref => this.containerRef = ref}>
                    {isLoading
                        ? <div className="order-tab-loading"><p>Loading order description</p></div>
                        : !!error
                            ? <div className="order-tab-error">
                                <Emoji id="crySad" />
                                <h2 className="title">Oops, error loading order {orderNumber}</h2>
                                <p className="notes">{error}</p>
                            </div>
                            : this.renderContent()
                    }
                </div>
                <div className="order-tab-footer">
                    {isLoading || tab !== TAB_MESSAGES
                        ? <OrderFooter orderNumber={orderNumber} standalone={standalone} />
                        : <OrderMessageBox orderNumber={orderNumber} isLoadingAdd={isLoadingAdd} addMessage={addMessage} addMessageAttach={addMessageAttach} />
                    }
                    {!!order && !order.naError && order.error &&
                        <OrderErrorModal onClose={this.onErrorCloseClick} onRefresh={invalidate} />
                    }
                </div>
            </div>
        );
    };
}

export default Order;



// WEBPACK FOOTER //
// ./src/components/order/Order.js